type Props = {
  width?: number
  height?: number
  viewBox?: string
  color?: string
  className?: string
}

export const CartIconHeader = ({
  width,
  height,
  viewBox,
  className,
  color,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.021 22.25C8.332 22.25 7.76599 21.69 7.76599 21C7.76599 20.31 8.32099 19.75 9.01099 19.75H9.021C9.711 19.75 10.271 20.31 10.271 21C10.271 21.69 9.711 22.25 9.021 22.25ZM18.271 21C18.271 20.31 17.711 19.75 17.021 19.75H17.011C16.321 19.75 15.766 20.31 15.766 21C15.766 21.69 16.331 22.25 17.021 22.25C17.711 22.25 18.271 21.69 18.271 21ZM13.001 13.75C12.591 13.75 12.251 13.41 12.251 13C12.251 12.59 12.591 12.25 13.001 12.25H20.069C20.216 12.25 20.341 12.143 20.365 11.998L20.96 8.35902C21.19 7.12902 20.24 5.99902 19 5.99902H6.94104L6.73206 4.61304C6.53806 3.24304 5.39203 2.24902 4.00903 2.24902H3.74902C3.33502 2.24902 2.99902 2.58502 2.99902 2.99902C2.99902 3.41302 3.33502 3.74902 3.74902 3.74902H3.99902C4.62602 3.74902 5.15805 4.21002 5.24805 4.83102L6.74902 15.279C6.88902 16.269 7.729 16.999 8.729 16.999H16.999C19.099 16.999 19.689 15.959 19.949 14.539L20.02 14.104C20.02 14.104 20.085 13.749 19.748 13.749C19.434 13.75 13.001 13.75 13.001 13.75Z"
      fill={color ?? 'black'}
    ></path>
  </svg>
)
